import { render, staticRenderFns } from "./tabla.vue?vue&type=template&id=ba180a58&scoped=true"
import script from "./tabla.vue?vue&type=script&lang=js"
export * from "./tabla.vue?vue&type=script&lang=js"
import style0 from "./tabla.vue?vue&type=style&index=0&id=ba180a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba180a58",
  null
  
)

export default component.exports